import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedinUser } from "../utils/StorageManager";

const QUICK_START_TOTAL_STEPS = 4;

const Navdata = () => {
  const history = useNavigate();

  const userSession = getLoggedinUser();
  const quickStartDone =
    parseInt(userSession?.user_quickStartStep ?? 0, 10) >= QUICK_START_TOTAL_STEPS;
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isProducts, setIsProducts] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isOrders, setIsOrders] = useState(false);
  const [isResources, setIsResources] = useState(false);
  const [isBilling, setIsBilling] = useState(false);
  const [isQuickStart, setIsQuickStart] = useState(false);
  const [isProfile, setIsProfile] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Products");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Products") {
      setIsProducts(false);
    }
    if (iscurrentState !== "Orders") {
      setIsOrders(false);
    }
    if (iscurrentState !== "Resources") {
      setIsResources(false);
    }
    if (iscurrentState !== "Billing") {
      setIsBilling(false);
    }
    if (iscurrentState !== "QuickStart") {
      setIsQuickStart(false);
    }
    if (iscurrentState !== "Profile") {
      setIsProfile(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isProducts,
    isAuth,
    isOrders,
    isResources,
    isBilling,
    isQuickStart,
    isProfile,
  ]);

  // Determina si el usuario es free trial (ajusta el campo si es necesario)
  const isFreeTrial = userSession?.user_freeType === 'trial';

  const menuItems = [
    // Welcome solo si es free trial
    ...(isFreeTrial ? [{
      id: "trialwelcome",
      label: "Welcome",
      icon: "mdi mdi-hand-wave-outline",
      link: "/trial-welcome",
      stateVariables: false,
      click: function (e) {
        e.preventDefault();
        setIscurrentState("TrialWelcome");
        updateIconSidebar(e);
      },
    }] : []),
    // Quick Start solo si NO es free trial
    ...(!isFreeTrial ? [{
      id: "quickstart",
      label: "Quick Start",
      icon: "mdi mdi-rocket-launch-outline",
      link: "/quickstart",
      badge: !quickStartDone ? { name: "!", className: "text-danger ms-1 fw-bold" } : { name: "✓", className: "text-success ms-1 fw-bold" },
      stateVariables: isQuickStart,
      click: function (e) {
        e.preventDefault();
        setIsQuickStart(!isQuickStart);
        setIscurrentState("QuickStart");
        updateIconSidebar(e);
      },
    }] : []),
    {
      id: "products",
      label: "Product catalog",
      icon: "mdi mdi-archive",
      link: "/products",
      stateVariables: isProducts,
      click: function (e) {
        e.preventDefault();
        setIsProducts(!isProducts);
        setIscurrentState("Products");
        updateIconSidebar(e);
      },
    },
    {
      id: "orders",
      label: "My Orders",
      icon: "mdi mdi-note-outline",
      link: "/orders",
      stateVariables: isOrders,
      click: function (e) {
        e.preventDefault();
        setIsOrders(!isOrders);
        setIscurrentState("Orders");
        updateIconSidebar(e);
      },
    },
    {
      id: "resources",
      label: "Resources",
      icon: "mdi mdi-information",
      link: "/resources",
      stateVariables: isResources,
      click: function (e) {
        e.preventDefault();
        setIsResources(!isResources);
        setIscurrentState("Resources");
        updateIconSidebar(e);
      },
    },
    {
      id: "profile",
      label: "Profile",
      icon: "mdi mdi-account-circle-outline",
      link: "/profile",
      stateVariables: isProfile,
      click: function (e) {
        e.preventDefault();
        setIsProfile(!isProfile);
        setIscurrentState("Profile");
        updateIconSidebar(e);
      },
    },
    {
      id: "billing",
      label: "Billing",
      icon: "ri-money-dollar-circle-line",
      link: "/billing",
      stateVariables: isBilling,
      click: function (e) {
        e.preventDefault();
        setIsBilling(!isBilling);
        setIscurrentState("Billing");
        updateIconSidebar(e);
      },
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;

/*
{
      id: "reports",
      label: "Reports",
      icon: "mdi mdi-google-analytics",
      link: "/reports",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },*/